import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IDevicePairRequest, IDevicePairResponse } from '../../../entity/interface/iAuthApis';

export interface IDevicePairingUseCase {
    execute(payload: IDevicePairRequest, apiKey: { [key: string]: string }): Promise<IDevicePairResponse>;
}

export class DevicePairingUseCase implements IDevicePairingUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(payload: IDevicePairRequest, apiKey: { [key: string]: string }): Promise<IDevicePairResponse> {
        return await this.authRepo.devicePairing(payload, apiKey);
    }
}
